import React from "react";
import { Container, Row, Col, Card, CardImg } from "reactstrap";
import cn from "classnames";

import Title from "../title/title";
import SubTitle from "../sub-title/sub-title";
// import ImageContainer from "../image-container/image-container";

import logo from "images/logo_azul.png";
import behanceportada from "images/behance.png";
import linkedin from "images/linkedin.png";

import * as style from "./portada.module.scss";

const behanceLink = "http://behacne.net/ofeliatadeo";
const linkedinLink = "https://es.linkedin.com/in/ofeliatadeo";

const Portada = () => {
  return (
    <Container fluid noGutters className={cn(style.portada, "no-padding")}>
      <Row noGutters>
        <div className={cn(style.portada__logo_container)}>
          <Card className={style.portada__logo}>
            <CardImg top src={logo} alt="Ofelia Tadeo Perez" />
          </Card>
        </div>

        <Row noGutters className={"no-padding"}>
          <Col
            xs={{ size: 12, offset: 0 }}
            sm={{ size: 12, offset: 0 }}
            md={{ size: 12, offset: 0 }}
            lg={{ size: 12, offset: 0 }}
            xl={{ size: 12, offset: 0 }}
          >
            <SubTitle
              classList={style.portada__name}
              text="Ofelia Tadeo Perez"
            />
          </Col>
        </Row>

        <div className={style.social__container_display}>
          <div className={style.social__container_size}>
            <Card className={style.card__border_none}>
              <a href={behanceLink}>
                <CardImg
                  top
                  src={behanceportada}
                  alt="Behance"
                  className={style.cardImg__size_social}
                />
              </a>
            </Card>
          </div>
          <div className={style.social__container_size}>
            <Card className={style.card__border_none}>
              <a href={linkedinLink}>
                <CardImg
                  top
                  src={linkedin}
                  alt="Linkedin"
                  className={style.cardImg__size_social}
                />
              </a>
            </Card>
          </div>
        </div>

        <Row>
          <Col
            xs={{ size: 12, offset: 1 }}
            sm={{ size: 12, offset: 1 }}
            md={{ size: 12, offset: 1 }}
            lg={{ size: 12, offset: 1 }}
            xl={{ size: 12, offset: 1 }}
          >
            <Title classList={style.portada__title} text="Hello!" />
            <SubTitle
              classList={style.portada__text}
              text="I am Ofelia, a multidisciplinary designer based in Gran Canaria."
            />
          </Col>
        </Row>
      </Row>
    </Container>
  );
};

export default Portada;
